// extracted by mini-css-extract-plugin
export default {"breadcrumbItemList":"BreadcrumbItemList_breadcrumbItemList__pen+j","breadcrumbItem":"BreadcrumbItemList_breadcrumbItem__BBaLg"};